var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPrintAction = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3A59",
    fillRule: "evenodd",
    d: "M16.667 13.61c0 .308-.238.557-.53.557h-.72V12.5c0-.92-.748-1.667-1.667-1.667h-7.5c-.919 0-1.666.748-1.666 1.667v1.667h-.72c-.293 0-.53-.25-.53-.556V8.056c0-.307.237-.556.53-.556H16.136c.294 0 .531.25.531.556v5.555zM6.25 15.834V12.5h7.5l.002 3.333H6.25zM6.68 4.167h6.655v1.666H6.673l.006-1.666zm9.457 1.666H15V4.167c0-.92-.685-1.667-1.527-1.667H6.528C5.685 2.5 5 3.248 5 4.167v1.666H3.864c-1.211 0-2.197.997-2.197 2.223v5.555c0 1.226.986 2.222 2.197 2.222h.72c0 .92.747 1.667 1.666 1.667h7.5c.92 0 1.667-.747 1.667-1.667h.72c1.21 0 2.197-.996 2.197-2.222V8.056c0-1.226-.986-2.223-2.198-2.223z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrintAction, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/print_action.8ec984a8.svg";
export { ForwardRef as ReactComponent };